/* global __CLIENT__ */

import qs from 'qs';

/**
 * Simple wrapper to get the URL hash on the client side, removing the # symbol.
 */
export const getHash = () => __CLIENT__ && (window.location.hash || '').slice(1);


/**
 * Converts hash string fragment to object map '#key=value' -> {key:value}
 * @param {string} normalizedString
 * @returns object
 */
export const getObjFromHashParamString = function (hashStringFragment) {
  let normalizedString;
  if (!hashStringFragment || typeof hashStringFragment !== 'string') return {};

  normalizedString = hashStringFragment.trim();
  if (normalizedString[0] === '#') {
    normalizedString = normalizedString.slice(1);
  }
  return qs.parse(normalizedString);
};

/**
 * Updates hash string fragment with values from passed obj
 * @param {Object} hashObj map of values to be updated/added on hash string
 * @param {string} currentHash hash string fragment to be processed
 * @returns string
 */
export const updateHashString = (hashObj, currentHash) => {
  const currentHashObj = getObjFromHashParamString(currentHash);
  const nextHashObj = { ...currentHashObj, ...hashObj };
  const hashString = qs.stringify(nextHashObj);
  if (hashString) {
    return `#${hashString}`;
  }
  return '';
};

/**
 * Simple wrapper to update URL hash on the client side only.
 */
export const updateHash = (hashObj) => {
  if (__CLIENT__) {
    window.location.hash = updateHashString(hashObj, getHash());
  }
};



// WEBPACK FOOTER //
// ./app/src/utils/urls.js